<app-shared-landing [landingRequest]="secureLandingRequest$ | async" (submitResult)="onSubmit($event)"
    [secureLandingFailed]="secureLandingFailed" [loader]="loader"></app-shared-landing>

